<div class="layout_content" id="layout-top">
  <div class="container_statics">
    <app-breadcrumb></app-breadcrumb>
    <article>
      <iframe id="termsAndConditions"
      title="Terminos y condiciones"
      src="https://novedades.jelpit.com/terminos-y-condiciones-portal/">
    </iframe>
    </article>
  </div>
</div>
